<template>
    <div class="load">
    </div>
</template>
<script>
    import ScrollPullDown from '@/public/ScrollPullDown'
    import ScrollHeaderMenu from '@/public/ScrollHeaderMenu'
    import Core from '@/until/core'
    export default {
        name: 'SaveLiveInfo',
        data () {
            return {
                text: '加载中...',
                options: {
                    step: 1,
                    beBack: true,
                    mobileExist: false,
                    existPassword: false,
                    timing: 0,
                    accessToken: null,
                    isMiniProgram: false
                },
                database: {
                    username: '',
                    password: '',
                    code: '',
                    mobile: ''
                }
            }
        },
        components: {
            ScrollPullDown,
            ScrollHeaderMenu
        },
        watch: {},
        computed: {
            BeBackStateEcho () {
                return this.options.step > 1 && this.options.beBack ? '上一步' : true
            },
            isRightUsername () {
                return true
                // const username = String(this.database.username || '')
                // return username.indexOf('@') !== -1 && username.length >= 4
            },
            isCodeLength () {
                return String(this.database.code || '').length >= 5
            },
            isPasswordLength () {
                return String(this.database.password || '').length >= 6
            },
            isRightMobile () {
                return /^1(3|4|5|7|8|9)\d{9}$/.test(this.database.mobile)
            }
        },
        filters: {},
        methods: {
            onReady () {
                const param = {}
                param.invite_fans_id = this.$route.params.ifId
                Core('Custommall/People/Readypc', param).then(res => {
                    const url = 'https://vzan.com/live/' + this.$route.params.zId
                    this.$store.commit('onChangeAppLoaderShow', false)
                    window.location.href = url
                })
            }
        },
        created () {
            Core.stopHistory(this.$route.fullPath, true)
        },
        mounted () {
            this.$store.commit('onChangeAppLoaderShow', true)
            window.document.title = '加载中..'
            const that = this
            Core.getMember('SaveLiveInfo', true).then(BODY => {
                that.database.port = BODY.PORT
                that.database.fans = BODY.FANS
                that.database.group = BODY.GROUP
                that.database.customer = BODY.CUSTOMER
                BODY.ASSEMBLE && that.$router.push(BODY.ASSEMBLE)
                Core.weChatJsdk([]).then((platForm) => {
                    if (platForm && platForm.isWx) {
                        // 微信中打开
                        wx.hideOptionMenu()
                    } else if (platForm) {
                        // 非微信浏览器打开
                    }
                })
                return that.$store.commit('onChangeAppLoaderShow', false)
            }).catch(error => {
                that.$store.commit('onChangeAppLoaderShow', false)
                return that.$store.commit('onChangeAppMessage', error)
            })
            that.options.accessToken = localStorage.getItem('staff:access-token')
            this.onReady()
            wx.miniProgram.getEnv(res => {
                if (res.miniprogram) { // 在小程序环境
                    that.options.isMiniProgram = true
                }
            })
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
.load{text-align: center; padding-top: 50px}
</style>



// WEBPACK FOOTER //
// src/components/SaveLiveInfo.vue